import { useQuery } from '@tanstack/react-query';
import { getSettings } from '../settings.api';

export function useSettings() {
  return useQuery({
    queryKey: ['admin', 'settings'],
    queryFn: getSettings,
    staleTime: 30 * 1000,
  });
}
